import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import "./App.css";
import "./index.css";
import Dashboard from "./pages/Dashboard/Dashboard";
import Reports from "./pages/Reports/report";
import TopCustomer from "./pages/TopCustomer/TopCustomer";
import TopTransactions from "./pages/TopTransactions/TopTransactions";
import Login from "./pages/Auth/login";
import Private from "./route/privateRoute";
import HandleMemberQuery from "./pages/HandleMemberQuery/HandleMemberQuery";
import HandleMemberProfile from "./pages/HandleMemberQuery/HandleMemberProfile";
import PointsManagement from "./pages/PointsManagement/PointsManagement";
import AdminAuditLog from "./pages/AdminAuditLog/AdminAuditLog";
import PointsAwardTransactions from "./pages/PointsAward/Transactions";
import PointsAwardAuditLog from "./pages/PointsAward/AuditLog";
import PointsAwardReports from "./pages/PointsAward/Reports";
import PointsAwardUpload from "./pages/PointsAward/Upload";
import ResetEnrolment from "./pages/ResetEnrolment/ResetEnrolment";
import TransactionChannel from "./pages/TransactionChannel/TransactionChannel";
import PointsApprovals from "./pages/PointsApprovals/PointsApprovals";
import ReviewPointsAdjustment from "./pages/PointsApprovals/ReviewPointsAdjustment";


function App() {
  const privateRoute = [
    {
      path: "/dashboard",
      title: "dashboard",
      component: Dashboard,
    },
    {
      path: "/reports/top-customer",
      title: "Top Customer",
      component: TopCustomer,
    },
    {
      path: "/customer-audit-log",
      title: "Top Transactions",
      component: TopTransactions,
    },
    {
      path: "/handle-member-query",
      title: "Handle Member Query",
      component: HandleMemberQuery,
    },
    {
      path: "/points-management",
      title: "Points Management",
      component: PointsManagement,
    },
    {
      path: "/points-award/transactions",
      title: "Points Award Transactions",
      component: PointsAwardTransactions,
    },
    {
      path: "/points-award/audit-log",
      title: "Points Award Audit Log",
      component: PointsAwardAuditLog,
    },
    {
      path: "/points-award/reports",
      title: "Points Award Reports",
      component: PointsAwardReports,
    },
    {
      path: "/points-award/upload",
      title: "Points Award Upload",
      component: PointsAwardUpload,
    },
    {
      path: "/admin-audit-log",
      title: "Admin Audit Log",
      component: AdminAuditLog,
    },
    {
      path: "/reports",
      title: "REPORTS",
      component: Reports,
    },
    {
      path: "/handle-member-query/:id",
      title: "Handle Member Query Profile",
      component: HandleMemberProfile,
    },
    {
      path: "/reset-enrolment",
      title: "Reset Enrolment",
      component: ResetEnrolment,
    },
    {
      path: "/transaction-channel",
      title: "Transaction Channel",
      component: TransactionChannel,
    },
    {
      path: "/points-approvals",
      title: "Points Approvals",
      component: PointsApprovals,
    },
    {
      path: "/points-approvals/:id",
      title: "Review Points Adjustment",
      component: ReviewPointsAdjustment,
    },

  ];
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          {privateRoute.map(({ path, component: Component }, index) => (
            <Route
              key={index}
              path={path}
              element={<Private Component={Component} />}
            />
          ))}
          {/* Define other routes here */}
          {/* <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/reports/top-customer" element={<TopCustomer />} />
          <Route path="/customer-audit-log" element={<TopTransactions />} /> */}
        </Routes>
      </Router>
    </div>
  );
}

export default App;
